import { Form, Input, Button, Skeleton, message } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import useallocationeditHook from './hooks'
import {
  SUPPLIER_ACCOUNT_MOBILE_INVALID,
  SUPPLIER_ACCOUNT_REAL_NAME_PATTERN,
  getSupplierAccountMobileRule,
  normalizeSupplierAccountMobile,
  rejectOversizeSupplierAccountMobilePaste,
} from '../../tools/supplierAccount'

const AllocationEdit = () => {
  const { form, loading, onFieldsChange, onClickSave, onClickClose } =
    useallocationeditHook()

  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }

  return (
    <div>
      <div className={Style['btnbox']}>
        <div className={Style['btn-left-box']}>操作</div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Button type="link" size="small" onClick={onClickSave}>
            提交
          </Button>
          <Button type="link" danger size="small" onClick={onClickClose}>
            关闭
          </Button>
        </div>
      </div>
      <div className={Style['container']}>
        <Form form={form} onFieldsChange={onFieldsChange}>
          <div className={Style['box']}>
            <div className={Style['box-form']}>
              <Skeleton loading={loading} active>
                <div className={Style['form-title']}>个人信息</div>
                <Form.Item label="姓名" {...itemLayou}>
                  <Form.Item
                    name="realName"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: '请输入姓名',
                      },
                      {
                        max: 50,
                        message: '姓名最多输入50个字符',
                      },
                      {
                        pattern: SUPPLIER_ACCOUNT_REAL_NAME_PATTERN,
                        message: '姓名仅支持中文、英文字母、空格、·和-',
                      },
                    ]}
                    noStyle
                  >
                    <Input />
                  </Form.Item>
                </Form.Item>
                <Form.Item label="邮箱" {...itemLayou}>
                  <Form.Item
                    name="mail"
                    rules={[
                      {
                        required: true,
                        pattern:
                          /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: '请输正确的入邮箱',
                      },
                      {
                        max: 50,
                        message: '邮箱不得超过50字符',
                      },
                    ]}
                    noStyle
                  >
                    <Input />
                  </Form.Item>
                </Form.Item>
                <Form.Item
                  label="手机号"
                  extra="请务必保证手机号准确性，此会作为后续员工登录的唯一验证"
                  {...itemLayou}
                >
                  <Form.Item
                    name="mobile"
                    normalize={normalizeSupplierAccountMobile}
                    rules={[getSupplierAccountMobileRule()]}
                    noStyle
                  >
                    <Input
                      maxLength={11}
                      onPaste={(event) => {
                        if (rejectOversizeSupplierAccountMobilePaste(event)) {
                          message.warning(SUPPLIER_ACCOUNT_MOBILE_INVALID)
                        }
                      }}
                    />
                  </Form.Item>
                </Form.Item>
              </Skeleton>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AllocationEdit
import { Form, Input, Button, Skeleton, message } from 'antd'
import Style from '../allocationadd/allocationadd.module.scss'
import useallocationeditHook from './hooks'
import {
  SUPPLIER_ACCOUNT_MOBILE_INVALID,
  SUPPLIER_ACCOUNT_REAL_NAME_PATTERN,
  getSupplierAccountMobileRule,
  normalizeSupplierAccountMobile,
  rejectOversizeSupplierAccountMobilePaste,
} from '../../tools/supplierAccount'

const AllocationEdit = () => {
  const { form, loading, onFieldsChange, onClickSave, onClickClose } =
    useallocationeditHook()

  const itemLayou = {
    style: {
      marginBottom: '10px',
      marginLeft: '30px',
    },
  }

  return (
    <div>
      <div className={Style['btnbox']}>
        <div className={Style['btn-left-box']}>操作</div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Button type="link" size="small" onClick={onClickSave}>
            提交
          </Button>
          <Button type="link" danger size="small" onClick={onClickClose}>
            关闭
          </Button>
        </div>
      </div>
      <div className={Style['container']}>
        <Form form={form} onFieldsChange={onFieldsChange}>
          <div className={Style['box']}>
            <div className={Style['box-form']}>
              <Skeleton loading={loading} active>
                <div className={Style['form-title']}>个人信息</div>
                <Form.Item label="姓名" {...itemLayou}>
                  <Form.Item
                    name="realName"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: '请输入姓名',
                      },
                      {
                        max: 50,
                        message: '姓名最多输入50个字符',
                      },
                      {
                        pattern: SUPPLIER_ACCOUNT_REAL_NAME_PATTERN,
                        message: '姓名仅支持中文、英文字母、空格、·和-',
                      },
                    ]}
                    noStyle
                  >
                    <Input />
                  </Form.Item>
                </Form.Item>
                <Form.Item label="邮箱" {...itemLayou}>
                  <Form.Item
                    name="mail"
                    rules={[
                      {
                        required: true,
                        pattern:
                          /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: '请输正确的入邮箱',
                      },
                      {
                        max: 50,
                        message: '邮箱不得超过50字符',
                      },
                    ]}
                    noStyle
                  >
                    <Input />
                  </Form.Item>
                </Form.Item>
                <Form.Item
                  label="手机号"
                  extra="请务必保证手机号准确性，此会作为后续员工登录的唯一验证"
                  {...itemLayou}
                >
                  <Form.Item
                    name="mobile"
                    normalize={normalizeSupplierAccountMobile}
                    rules={[getSupplierAccountMobileRule()]}
                    noStyle
                  >
                    <Input
                      maxLength={11}
                      onPaste={(event) => {
                        if (rejectOversizeSupplierAccountMobilePaste(event)) {
                          message.warning(SUPPLIER_ACCOUNT_MOBILE_INVALID)
                        }
                      }}
                    />
                  </Form.Item>
                </Form.Item>
              </Skeleton>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AllocationEdit
